import { render } from "./PointsCalculatorDialog.vue?vue&type=template&id=ebfb6228&scoped=true"
import script from "./PointsCalculatorDialog.vue?vue&type=script&lang=js"
export * from "./PointsCalculatorDialog.vue?vue&type=script&lang=js"

import "./PointsCalculatorDialog.vue?vue&type=style&index=0&id=ebfb6228&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebfb6228"]])

export default __exports__